import { RevenueBreakdown } from 'pages/Optimisation/components/SummaryCards/RevenueBreakdownCard/RevenueBreakdownCard.types';

export const sortDataDescending = (array: RevenueBreakdown[]) => {
  return [...array].sort((a, b) => b.revenue - a.revenue);
};

export const sortDataAscending = (array: RevenueBreakdown[]) => {
  return [...array].sort((a, b) => a.revenue - b.revenue);
};

export const sortPositiveValuesAscending = (array: RevenueBreakdown[]) => {
  const negativeNum = [];
  const positiveNum = [];

  for (let i = 0; i < array.length; i++) {
    if (array[i].revenue > 0) {
      positiveNum.push(array[i]);
    } else {
      negativeNum.push(array[i]);
    }
  }

  positiveNum.sort((a, b) => b.revenue - a.revenue);

  return [...negativeNum, ...positiveNum];
};

export const convertTitleCase = (string?: string) => {
  if (!string) {
    return '';
  }

  return string
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();
};

/* capitalizeSpecificFirstMarketWords will only capitalize 2 or 3 letter words that start with D, F or O and end with MCR and have an f or t in the middle optionally */

export const capitalizeSpecificFirstMarketWords = (string: string) => {
  if (!string) {
    return '';
  }

  return (
    string
      .replace(/[DFO]f?t?[mcr]/, (match) => match.toUpperCase())
      .replace(/Bid|Offer/, (match) => match.toLowerCase())
      // add 'Wholesale' to the beginning of the string
      .replace('Day Ahead', 'Wholesale DA')
      .replace(/Intraday/, 'Wholesale Intraday')
      .replace(/System/, 'Wholesale System')
      .replace(/Qr/, 'QR')
      .replace(/Br/, 'BR')
      .replace(/Sr/, 'SR')
  );
};
